import React from "react"
import { PageHero } from "../ui/page-hero"

export function ServicesHero() {
  return (
    <PageHero
      title="Our Services"
      description="We structure institutional knowledge to create AI systems that compound value over time. From strategic assessment to Partner AI deployment, our services build sustainable AI capability that improves as technology advances."
      backgroundImage="/images/backgrounds/flickr-3053484996.jpg"
      backgroundAlt="AI Services"
    />
  )
}